export class NewsletterITem {
}
export default class Newsletter {
    static fromApi(response, lang) {
        var _a, _b, _c, _d, _e, _f;
        const newsletter = new Newsletter();
        const translation = (_a = response === null || response === void 0 ? void 0 : response.translations) === null || _a === void 0 ? void 0 : _a[0];
        const items = (_b = response === null || response === void 0 ? void 0 : response.newsletter_page_items) !== null && _b !== void 0 ? _b : '';
        newsletter.items = new Array();
        newsletter.title = (_c = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _c !== void 0 ? _c : '';
        if (items) {
            for (const item of items) {
                const newsletterItem = new NewsletterITem();
                const translation = (_d = item === null || item === void 0 ? void 0 : item.translations) === null || _d === void 0 ? void 0 : _d.find(t => { var _a; return ((_a = t === null || t === void 0 ? void 0 : t.languages_code) === null || _a === void 0 ? void 0 : _a.lang) == lang; });
                newsletterItem.title = (_e = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _e !== void 0 ? _e : '';
                newsletterItem.url = (_f = translation === null || translation === void 0 ? void 0 : translation.url) !== null && _f !== void 0 ? _f : '';
                newsletter.items.push(newsletterItem);
            }
        }
        return newsletter;
    }
}
